import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Product/Search/';

const state = {
  session: {}
};

const mutations = {};

const actions = {

  GetHotKeyword({commit}, view) {
    return request.PromiseCall(basePath, 'GetHotKeyword', view);
  },
  CheckTeam({commit}, view) {
    return request.PromiseCall(basePath, 'CheckTeam', view);
  },

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Product/Search/index.js